import { appActions } from '@/store/slices/appSlice'
import { AppDispatch, RootState } from '@/store/store'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

export const useFullScreen = () => {
  const { isFullScreen } = useSelector((state: RootState) => state.app)
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    if (isFullScreen) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      }
    } else if (document.fullscreenElement) {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      }
    }
  }, [isFullScreen])

  const toggleFullscreen = () => {
    dispatch(appActions.setFullScreen(!isFullScreen))
  }

  return { isFullScreen, toggleFullscreen }
}
